/**
 * Tutorial videos hosted on Broadcast.
 *
 * More videos are planned, so the Resources page renders these lists rather than
 * hardcoding embeds — adding one is a single entry here.
 *
 * `broadcastId` is the number in the video's URL
 * (broadcast.amazon.com/videos/<id>); the player is served from
 * broadcast.amazon.com/embed/<id>, which is the embed URL Broadcast publishes
 * under a video's "More Information" tab.
 */

export interface Tutorial {
  readonly broadcastId: string;
  readonly title: string;
}

/** Kept apart from the plugin tutorials: these cover Navigator itself, not the plugin. */
export const GETTING_STARTED_TUTORIALS: readonly Tutorial[] = [
  {
    broadcastId: '2192339',
    title: 'Recording and validating an incident in WHS Navigator',
  },
];

/**
 * Tutorials for the auto-fill plugin, shown under the plugin section.
 *
 * Install first, then use: someone arriving here without the plugin needs the first
 * before the second is any help, and the Resources page renders them in this order.
 */
export const AUTOFILL_TUTORIALS: readonly Tutorial[] = [
  {
    broadcastId: '2149603',
    title: 'Installing the Auto-Fill plugin for AUSTIN',
  },
  {
    broadcastId: '2202773',
    title: 'Auto-filling an AUSTIN incident report from WHS Navigator',
  },
];

export const broadcastEmbedUrl = (broadcastId: string): string =>
  `https://broadcast.amazon.com/embed/${broadcastId}`;

export const broadcastVideoUrl = (broadcastId: string): string =>
  `https://broadcast.amazon.com/videos/${broadcastId}`;
